module.exports = __webpack_public_path__ + "img/Daños por Caída de Aditamentos.9e5476a5.svg";